import { useExpenseQuery } from "web_myplann/Api/Finances/useExpenseQuery";
import { useIncomeQuery } from "web_myplann/Api/Finances/useIncomeQuery";
import {
	mapExpenseToChartData,
	mapIncomeToChartData,
} from "web_myplann/Finances/Helpers/mapFinanceChartData";
import { useSyncFinanceState } from "web_myplann/Finances/Hooks/useSyncFinanceState";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";

export const useFinanceData = () => {
	const { t } = useResource();

	const { data: expenses } = useExpenseQuery();
	const { data: income } = useIncomeQuery();

	useSyncFinanceState();

	const totalIncome =
		income?.data?.reduce((acc, curr) => acc + curr.amount, 0) ?? 0;

	const incomeData = income?.data?.map(mapIncomeToChartData) ?? [];

	const totalExpenses =
		expenses?.data?.reduce((acc, curr) => acc + curr.monthlyPayment, 0) ?? 0;

	const expenseData =
		expenses?.data?.map((expense) => mapExpenseToChartData(expense, t)) ?? [];

	return { incomeData, totalIncome, totalExpenses, expenseData };
};
